export const regions = [
  {
    country: 'Hong Kong',
    state: 'Islands District',
  },
  {
    country: 'Hong Kong',
    state: 'Kwai Tsing District',
  },
  {
    country: 'Hong Kong',
    state: 'North District',
  },
  {
    country: 'Hong Kong',
    state: 'Sai Kung District',
  },
  {
    country: 'Hong Kong',
    state: 'Sha Tin District',
  },
  {
    country: 'Hong Kong',
    state: 'Tsuen Wan District',
  },
  {
    country: 'Hong Kong',
    state: 'Tuen Mun District',
  },
  {
    country: 'Hong Kong',
    state: 'Yuen Long District',
  },
  {
    country: 'Hong Kong',
    state: 'Tai Po District',
  },
  {
    country: 'Hong Kong',
    state: 'Kowloon City District',
  },
  {
    country: 'Hong Kong',
    state: 'Kwun Tong District',
  },
  {
    country: 'Hong Kong',
    state: 'Sham Shui District',
  },
  {
    country: 'Hong Kong',
    state: 'Wong Tai Sin District',
  },
  {
    country: 'Hong Kong',
    state: 'Yau Tsim Mong District',
  },
  {
    country: 'Hong Kong',
    state: 'Central & Western District',
  },
  {
    country: 'Hong Kong',
    state: 'Eastern District',
  },
  {
    country: 'Hong Kong',
    state: 'Southern District',
  },
  {
    country: 'Hong Kong',
    state: 'Wan Chai District',
  },
  {
    country: 'Kuwait',
    state: 'Kuwait City',
  },
  {
    country: 'Kuwait',
    state: 'Siddeeq',
  },
  {
    country: 'Kuwait',
    state: 'Ahmadi',
  },
  {
    country: 'Kuwait',
    state: 'Jileeb Al-Shiyukh',
  },
  {
    country: 'Kuwait',
    state: 'Al Jahra',
  },
  {
    country: 'Kuwait',
    state: 'North West Sulaibikhat',
  },
  {
    country: 'Honduras',
    state: 'Tegucigalpa',
  },
  {
    country: 'Honduras',
    state: 'Comayaga',
  },
  {
    country: 'Honduras',
    state: 'Islas de la Bahia',
  },
  {
    country: 'El Salvador',
    state: 'San Francisco Gotera',
  },
  {
    country: 'El Salvador',
    state: 'San Miguel',
  },
  {
    country: 'El Salvador',
    state: 'Neuva Guadalupe',
  },
  {
    country: 'El Salvador',
    state: 'El Triunfo',
  },
  {
    country: 'El Salvador',
    state: 'Vista Hermosa',
  },
  {
    country: 'El Salvador',
    state: 'San Lorenzo',
  },
  {
    country: 'El Salvador',
    state: 'Caserío Los Jobos',
  },
  {
    country: 'El Salvador',
    state: 'Santo Domingo',
  },
  {
    country: 'El Salvador',
    state: 'Ilobasco',
  },
  {
    country: 'El Salvador',
    state: 'La Unión',
  },
  {
    country: 'El Salvador',
    state: 'San Juan Talpa',
  },
  {
    country: 'El Salvador',
    state: 'San Tomás',
  },
  {
    country: 'El Salvador',
    state: 'San Marcos',
  },
  {
    country: 'El Salvador',
    state: 'Santa Tecla',
  },
  {
    country: 'El Salvador',
    state: 'Colón',
  },
  {
    country: 'El Salvador',
    state: 'Ciudad Arce',
  },
  {
    country: 'El Salvador',
    state: 'Las Aradas',
  },
  {
    country: 'El Salvador',
    state: 'El Guineo',
  },
  {
    country: 'United States',
    state: 'Alaska',
  },
  {
    country: 'Andorra',
    state: 'Sant Julià de Lòria',
  },
  {
    country: 'Andorra',
    state: 'Andorra la Vella',
  },
  {
    country: 'Andorra',
    state: 'La Massana',
  },
  {
    country: 'Andorra',
    state: 'Ordino',
  },
  {
    country: 'Andorra',
    state: 'La Cortinada',
  },
  {
    country: 'Andorra',
    state: 'Encamp',
  },
  {
    country: 'United States',
    state: 'Hawaii',
  },
  {
    country: 'Andorra',
    state: 'Canillo',
  },
  {
    country: 'Andorra',
    state: 'El Tarter',
  },
  {
    country: 'Barbados',
    state: 'Oistins',
  },
  {
    country: 'Barbados',
    state: 'Bridgetown',
  },
  {
    country: 'Barbados',
    state: 'Holetown',
  },
  {
    country: 'Barbados',
    state: 'Speightstown',
  },
  {
    country: 'Barbados',
    state: 'Belleplaine',
  },
  {
    country: 'Barbados',
    state: 'Bathsheba',
  },
  {
    country: 'Barbados',
    state: 'Bath',
  },
  {
    country: 'Barbados',
    state: 'Sherbourne',
  },
  {
    country: 'Trinidad and Tobago',
    state: 'Port of Spain',
  },
  {
    country: 'Trinidad and Tobago',
    state: 'San Juan',
  },
  {
    country: 'Trinidad and Tobago',
    state: 'Maracas',
  },
  {
    country: 'Barbados',
    state: 'Six Cross Roads',
  },
  {
    country: 'Andorra',
    state: 'El Pas de la Casa',
  },
  {
    country: 'Liechtenstein',
    state: 'Mauren',
  },
  {
    country: 'Liechtenstein',
    state: 'Eschen',
  },
  {
    country: 'Liechtenstein',
    state: 'Schaan',
  },
  {
    country: 'Liechtenstein',
    state: 'Vaduz',
  },
  {
    country: 'Liechtenstein',
    state: 'Triesen',
  },
  {
    country: 'Liechtenstein',
    state: 'Balzers',
  },
  {
    country: 'Monaco',
    state: 'Moneghetti',
  },
  {
    country: 'Monaco',
    state: 'La Condamine',
  },
  {
    country: 'Monaco',
    state: 'Monaco-Ville',
  },
  {
    country: 'Monaco',
    state: 'Les Revoires',
  },
  {
    country: 'Monaco',
    state: 'La Colle',
  },
  {
    country: 'San Marino',
    state: 'City of San Marino',
  },
  {
    country: 'San Marino',
    state: 'Borgo Maggiore',
  },
  {
    country: 'United States',
    state: 'Florida',
  },
  {
    country: 'Burkina Faso',
    state: 'Ouagadougou',
  },
  {
    country: 'Burkina Faso',
    state: 'Loumbila',
  },
  {
    country: 'Burkina Faso',
    state: 'Ziniaré',
  },
  {
    country: 'Burkina Faso',
    state: 'Komsilga',
  },
  {
    country: 'Burkina Faso',
    state: 'Loumbila',
  },
  {
    country: 'Tanzania',
    state: 'Dar es Salaam',
  },
  {
    country: 'Kyrgyzstan',
    state: 'Bishkek',
  },
  {
    country: 'Kyrgyzstan',
    state: 'Tokmok',
  },
  {
    country: 'Kyrgyzstan',
    state: 'Kemin',
  },
  {
    country: 'Kyrgyzstan',
    state: 'Tort-Kul',
  },
  {
    country: 'Cambodia',
    state: 'Phnom Penh',
  },
  {
    country: 'Cambodia',
    state: 'Ta Khmao',
  },
  {
    country: 'Cambodia',
    state: 'Angk Snuol District',
  },
  {
    country: 'Cambodia',
    state: 'Chbar Mon',
  },
  {
    country: 'San Marino',
    state: 'Faetano',
  },
  {
    country: 'Singapore',
    state: 'Tuas',
  },
  {
    country: 'Singapore',
    state: 'Jurong West',
  },
  {
    country: 'Singapore',
    state: 'Jurong',
  },
  {
    country: 'Singapore',
    state: 'Sungei Kadut',
  },
  {
    country: 'Singapore',
    state: 'Woodlands',
  },
  {
    country: 'Singapore',
    state: 'WSAG',
  },
  {
    country: 'Singapore',
    state: 'Punggol',
  },
  {
    country: 'Singapore',
    state: 'QPG',
  },
  {
    country: 'Singapore',
    state: 'Changi Business Park',
  },
  {
    country: 'Singapore',
    state: 'Downtown Core',
  },
  {
    country: 'Singapore',
    state: 'Little India',
  },
  {
    country: 'Singapore',
    state: 'Toa Payoh',
  },
  {
    country: 'Singapore',
    state: 'Bishan',
  },
  {
    country: 'Singapore',
    state: 'Sentosa',
  },
  {
    country: 'Qatar',
    state: 'Doha',
  },
  {
    country: 'Germany',
    state: 'Mecklenburg-Vorpommern',
  },
  {
    country: 'Finland',
    state: 'Southern Finland Province',
  },
  {
    country: 'Finland',
    state: 'North Ostrobothnia',
  },
  {
    country: 'Finland',
    state: 'Mainland Finland',
  },
  {
    country: 'Finland',
    state: 'Northern Savonia',
  },
  {
    country: 'Finland',
    state: 'Southern Savonia',
  },
  {
    country: 'Finland',
    state: 'South Karelia',
  },
  {
    country: 'Finland',
    state: 'Kymenlaakso',
  },
  {
    country: 'Finland',
    state: 'Uusimaa',
  },
  {
    country: 'Finland',
    state: 'Southwest Finland',
  },
  {
    country: 'Finland',
    state: 'Satakunta',
  },
  {
    country: 'Finland',
    state: 'Pirkanamaa',
  },
  {
    country: 'Finland',
    state: 'Kanta-Häme',
  },
  {
    country: 'Italy',
    state: 'Campania',
  },
  {
    country: 'Italy',
    state: 'Umbria',
  },
  {
    country: 'Italy',
    state: 'Toscany',
  },
  {
    country: 'Austria',
    state: 'Styria',
  },
  {
    country: 'Italy',
    state: 'Veneto',
  },
  {
    country: 'Italy',
    state: 'Emilia-Romagna',
  },
  {
    country: 'Italy',
    state: 'Aosta Valley',
  },
  {
    country: 'Italy',
    state: 'Basilicata',
  },
  {
    country: 'Netherlands',
    state: 'Friesland',
  },
  {
    country: 'Italy',
    state: 'Trentino-Alto Adige/Südtirol',
  },
  {
    country: 'Netherlands',
    state: 'Overijssel',
  },
  {
    country: 'Netherlands',
    state: 'Caribbean Netherlands',
  },
  {
    country: 'Netherlands',
    state: 'Drenthe',
  },
  {
    country: 'Netherlands',
    state: 'North Holland',
  },
  {
    country: 'Italy',
    state: 'Piedmont',
  },
  {
    country: 'Netherlands',
    state: 'Gelderland',
  },
  {
    country: 'Netherlands',
    state: 'Utrecht',
  },
  {
    country: 'Italy',
    state: 'Lazio',
  },
  {
    country: 'Netherlands',
    state: 'Limburg',
  },
  {
    country: 'Italy',
    state: 'Molise',
  },
  {
    country: 'Netherlands',
    state: 'South Holland',
  },
  {
    country: 'Israel',
    state: 'Tel Aviv',
  },
  {
    country: 'Israel',
    state: 'Center District',
  },
  {
    country: 'Israel',
    state: 'Haifa District',
  },
  {
    country: 'Netherlands',
    state: 'Flevoland',
  },
  {
    country: 'Hungary',
    state: 'Bács-Kiskun',
  },
  {
    country: 'Hungary',
    state: 'Baranya',
  },
  {
    country: 'Hungary',
    state: 'Békés',
  },
  {
    country: 'Hungary',
    state: 'Borsod-Abaúj-Zemplén',
  },
  {
    country: 'Hungary',
    state: 'Budapest',
  },
  {
    country: 'Hungary',
    state: 'Csongrád-Csanád',
  },
  {
    country: 'Hungary',
    state: 'Fejér',
  },
  {
    country: 'Hungary',
    state: 'Győr-Moson-Sopron',
  },
  {
    country: 'Hungary',
    state: 'Hajdú-Bihar',
  },
  {
    country: 'Hungary',
    state: 'Heves',
  },
  {
    country: 'Hungary',
    state: 'Jász-Nagykun-Szolnok',
  },
  {
    country: 'Hungary',
    state: 'Komárom-Esztergom',
  },
  {
    country: 'Hungary',
    state: 'Nógrád',
  },
  {
    country: 'Hungary',
    state: 'Pest',
  },
  {
    country: 'Hungary',
    state: 'Somogy',
  },
  {
    country: 'Hungary',
    state: 'Szabolcs-Szatmár-Bereg',
  },
  {
    country: 'Hungary',
    state: 'Tolna',
  },
  {
    country: 'Hungary',
    state: 'Vas',
  },
  {
    country: 'Hungary',
    state: 'Veszprém',
  },
  {
    country: 'Hungary',
    state: 'Zala',
  },
  {
    country: 'Israel',
    state: 'Jerusalem District',
  },
  {
    country: 'Israel',
    state: 'North District',
  },
  {
    country: 'Netherlands',
    state: 'Groningen',
  },
  {
    country: 'Italy',
    state: 'Lombardy',
  },
  {
    country: 'Denmark',
    state: 'North Denmark Region',
  },
  {
    country: 'Denmark',
    state: 'Capital Region of Denmark',
  },
  {
    country: 'Netherlands',
    state: 'Zeeland',
  },
  {
    country: 'Colombia',
    state: 'Cundinamarca',
  },
  {
    country: 'Taiwan',
    state: 'Taipei',
  },
  {
    country: 'Lithuania',
    state: 'Taurage County',
  },
  {
    country: 'Colombia',
    state: 'Tolima',
  },
  {
    country: 'Colombia',
    state: 'Caldas',
  },
  {
    country: 'Lithuania',
    state: 'Telšiai County',
  },
  {
    country: 'Lithuania',
    state: 'Alytus County',
  },
  {
    country: 'Lithuania',
    state: 'Kaunas County',
  },
  {
    country: 'Lithuania',
    state: 'Klaipeda County',
  },
  {
    country: 'Lithuania',
    state: 'Vilnius County',
  },
  {
    country: 'Lithuania',
    state: 'Utena County',
  },
  {
    country: 'Lithuania',
    state: 'Panevezys County',
  },
  {
    country: 'Lithuania',
    state: 'Marijampole County',
  },
  {
    country: 'Montenegro',
    state: 'Pljevlja',
  },
  {
    country: 'Montenegro',
    state: 'Žabljak',
  },
  {
    country: 'Montenegro',
    state: 'Šavnik',
  },
  {
    country: 'Montenegro',
    state: 'Nikšić',
  },
  {
    country: 'Montenegro',
    state: 'Danilovgrad',
  },
  {
    country: 'Montenegro',
    state: 'Kotor',
  },
  {
    country: 'Montenegro',
    state: 'Tivat',
  },
  {
    country: 'Montenegro',
    state: 'Herceg Novi',
  },
  {
    country: 'Montenegro',
    state: 'Baošici',
  },
  {
    country: 'Montenegro',
    state: 'Dobrota',
  },
  {
    country: 'Montenegro',
    state: 'Budva',
  },
  {
    country: 'Montenegro',
    state: 'Cetinje',
  },
  {
    country: 'Montenegro',
    state: 'Podgorica',
  },
  {
    country: 'Montenegro',
    state: 'Tuzi',
  },
  {
    country: 'Montenegro',
    state: 'Kolašin',
  },
  {
    country: 'Montenegro',
    state: 'Mojkovac Municipality',
  },
  {
    country: 'Montenegro',
    state: 'Bijelo Polje',
  },
  {
    country: 'Montenegro',
    state: 'Bar',
  },
  {
    country: 'Montenegro',
    state: 'Ulcinj',
  },
  {
    country: 'Jamaica',
    state: 'Montego Bay',
  },
  {
    country: 'Jamaica',
    state: 'Kingston',
  },
  {
    country: 'Colombia',
    state: 'Antioquia',
  },
  {
    country: 'Sweden',
    state: 'Östergötland County',
  },
  {
    country: 'Japan',
    state: 'Watarai County',
  },
  {
    country: 'Japan',
    state: 'Chubu Region',
  },
  {
    country: 'Lithuania',
    state: 'Siauliai County',
  },
  {
    country: 'Morocco',
    state: 'Tangier',
  },
  {
    country: 'Morocco',
    state: 'Rabat',
  },
  {
    country: 'Morocco',
    state: 'Fez',
  },
  {
    country: 'Morocco',
    state: 'Melilla',
  },
  {
    country: 'Morocco',
    state: 'Casablanca',
  },
  {
    country: 'Morocco',
    state: 'Marrakesh',
  },
  {
    country: 'Morocco',
    state: 'Tinghir',
  },
  {
    country: 'Norway',
    state: 'Nordland',
  },
  {
    country: 'Norway',
    state: 'Westland',
  },
  {
    country: 'Norway',
    state: 'Innlandet',
  },
  {
    country: 'Norway',
    state: 'Møre and Romsdal',
  },
  {
    country: 'Norway',
    state: 'Oslo',
  },
  {
    country: 'Colombia',
    state: 'Caldas',
  },
  {
    country: 'Norway',
    state: 'Rogaland',
  },
  {
    country: 'Czechia',
    state: 'Prague',
  },
  {
    country: 'Czechia',
    state: 'Central Bohemia',
  },
  {
    country: 'Czechia',
    state: 'South Bohemia',
  },
  {
    country: 'Czechia',
    state: 'Plzeň',
  },
  {
    country: 'Czechia',
    state: 'Karlovy Vary',
  },
  {
    country: 'Czechia',
    state: 'Ústí nad Labem',
  },
  {
    country: 'Czechia',
    state: 'Liberec',
  },
  {
    country: 'Czechia',
    state: 'Hradec Králové',
  },
  {
    country: 'Czechia',
    state: 'Pardubice',
  },
  {
    country: 'Czechia',
    state: 'Olomouc',
  },
  {
    country: 'Czechia',
    state: 'Moravian-Silesian',
  },
  {
    country: 'Czechia',
    state: 'Zlín',
  },
  {
    country: 'Czechia',
    state: 'South Moravia',
  },
  {
    country: 'Czechia',
    state: 'Vysočina',
  },

  {
    country: 'Japan',
    state: 'Wakayama Prefecture',
  },
  {
    country: 'United States',
    state: 'Rhode Island',
  },
  {
    country: 'Norway',
    state: 'Trøndelag',
  },
  {
    country: 'Canada',
    state: 'Alberta',
  },
  {
    country: 'Canada',
    state: 'Yukon',
  },
  {
    country: 'Canada',
    state: 'Nova Scotia',
  },
  {
    country: 'Paraguay',
    state: 'Central Department',
  },
  {
    country: 'Paraguay',
    state: 'Cordillera Department',
  },
  {
    country: 'Canada',
    state: 'Saskatchewan',
  },
  {
    country: 'Slovakia',
    state: 'Region of Košice',
  },
  {
    country: 'Slovakia',
    state: 'Region of Žilina',
  },
  {
    country: 'Slovakia',
    state: 'Region of Bratislava',
  },
  {
    country: 'Slovakia',
    state: 'Region of Trnava',
  },
  {
    country: 'Slovakia',
    state: 'Region of Banská Bystrica',
  },
  {
    country: 'Slovenia',
    state: 'Pomurska',
  },
  {
    country: 'Slovenia',
    state: 'Podravska',
  },
  {
    country: 'Slovenia',
    state: 'Koroška',
  },
  {
    country: 'Slovenia',
    state: 'Savinjska',
  },
  {
    country: 'Slovenia',
    state: 'Zasavska',
  },
  {
    country: 'Slovenia',
    state: 'Posavska',
  },
  {
    country: 'Slovenia',
    state: 'Jugovzhodna Slovenija',
  },
  {
    country: 'Slovenia',
    state: 'Osrednjeslovenska',
  },
  {
    country: 'Slovenia',
    state: 'Gorenjska',
  },
  {
    country: 'Slovenia',
    state: 'Primorsko-notranjska',
  },
  {
    country: 'Slovenia',
    state: 'Goriška',
  },
  {
    country: 'Slovenia',
    state: 'Obalno-kraška',
  },
  {
    country: 'Armenia',
    state: 'Yerevan',
  },
  {
    country: 'Armenia',
    state: 'Armavir Province',
  },
  {
    country: 'Armenia',
    state: 'Kotayk Province',
  },
  {
    country: 'Armenia',
    state: 'Ararat Province',
  },
  {
    country: 'Armenia',
    state: 'Shirak Province',
  },
  {
    country: 'Armenia',
    state: 'Syunik Province',
  },
  {
    country: 'Armenia',
    state: 'Vayots Dzor Province',
  },
  {
    country: 'Japan',
    state: 'Hyogo Prefecture',
  },
  {
    country: 'Estonia',
    state: 'Ida-Viru County',
  },
  {
    country: 'Estonia',
    state: 'Lääne-Viru County',
  },
  {
    country: 'Estonia',
    state: 'Harju County',
  },
  {
    country: 'Estonia',
    state: 'Hiiu County',
  },
  {
    country: 'Estonia',
    state: 'Saare County',
  },
  {
    country: 'Estonia',
    state: 'Lääne County',
  },
  {
    country: 'Estonia',
    state: 'Rapla County',
  },
  {
    country: 'Estonia',
    state: 'Pärnu County',
  },
  {
    country: 'Estonia',
    state: 'Järva County',
  },
  {
    country: 'Estonia',
    state: 'Jõgeva County',
  },
  {
    country: 'Estonia',
    state: 'Tartu County',
  },
  {
    country: 'Estonia',
    state: 'Põlva County',
  },
  {
    country: 'Estonia',
    state: 'Võru County',
  },
  {
    country: 'Estonia',
    state: 'Valga County',
  },
  {
    country: 'Estonia',
    state: 'Viljandi County',
  },
  {
    country: 'Japan',
    state: 'Fukui Prefecture',
  },
  {
    country: 'Paraguay',
    state: 'San Pedro',
  },
  {
    country: 'Slovakia',
    state: 'Region of Nitra',
  },
  {
    country: 'Japan',
    state: 'Shiga Prefecture',
  },
  {
    country: 'Slovakia',
    state: 'Region of Trenčín',
  },
  {
    country: 'Japan',
    state: 'Oita Prefecture',
  },
  {
    country: 'South Africa',
    state: 'Mpumalanga',
  },
  {
    country: 'Spain',
    state: 'Valencian Community',
  },
  {
    country: 'Spain',
    state: 'Community of Madrid',
  },
  {
    country: 'Spain',
    state: 'Catalonia',
  },
  {
    country: 'Spain',
    state: 'Andalusia',
  },
  {
    country: 'Spain',
    state: 'Aragon',
  },
  {
    country: 'Jordan',
    state: 'Amman',
  },
  {
    country: 'South Africa',
    state: 'Gauteng',
  },
  {
    country: 'Jordan',
    state: 'Sakib',
  },
  {
    country: 'Jordan',
    state: 'Al Fuhays',
  },
  {
    country: 'Jordan',
    state: 'Sahab',
  },
  {
    country: 'Jordan',
    state: 'Madaba',
  },
  {
    country: 'Jordan',
    state: 'Iraq Al-Amir',
  },
  {
    country: 'Iran',
    state: 'Gilan',
  },
  {
    country: 'Iran',
    state: 'Qazvin',
  },
  {
    country: 'Iran',
    state: 'Alborz',
  },
  {
    country: 'Iran',
    state: 'Mazandaran',
  },
  {
    country: 'Iran',
    state: 'Tehran',
  },
  {
    country: 'Iran',
    state: 'Isfahan',
  },
  {
    country: 'Iran',
    state: 'Shiraz',
  },
  {
    country: 'South Africa',
    state: 'Johannesburg',
  },
  {
    country: 'South Africa',
    state: 'Upington',
  },
  {
    country: 'South Africa',
    state: 'Pretoria',
  },
  {
    country: 'South Africa',
    state: 'Cape Town',
  },
  {
    country: 'Guatemala',
    state: 'Guatemala City',
  },
  {
    country: 'Spain',
    state: 'Extremadura',
  },
  {
    country: 'Slovakia',
    state: 'Region of Prešov',
  },
  {
    country: 'South Africa',
    state: 'Limpopo',
  },
  {
    country: 'South Africa',
    state: 'Cape Town',
  },
  {
    country: 'Japan',
    state: 'Osaka Prefecture',
  },
  {
    country: 'Canada',
    state: 'Manitoba',
  },
  {
    country: 'Spain',
    state: 'Rioja',
  },
  {
    country: 'Spain',
    state: 'Castile and León',
  },
  {
    country: 'Spain',
    state: 'Navarre',
  },
  {
    country: 'Canada',
    state: 'British Columbia',
  },
  {
    country: 'Spain',
    state: 'Castile–La Mancha',
  },
  {
    country: 'Lebanon',
    state: 'Beirut Governorate',
  },
  {
    country: 'Lebanon',
    state: 'Mount Lebanon',
  },
  {
    country: 'Venezuela',
    state: 'Miranda State',
  },
  {
    country: 'Italy',
    state: 'Liguria',
  },
  {
    country: 'Lesotho',
    state: 'Maseru',
  },
  {
    country: 'Poland',
    state: 'Opole Voivodeship',
  },
  {
    country: 'Poland',
    state: 'Lesser Poland Voivodeship',
  },
  {
    country: 'Poland',
    state: 'Podlaskie Voivodeship',
  },
  {
    country: 'United States',
    state: 'North Carolina',
  },
  {
    country: 'United States',
    state: 'Virginia',
  },
  {
    country: 'Poland',
    state: 'Łódzkie Voivodship',
  },
  {
    country: 'United States',
    state: 'South Carolina',
  },
  {
    country: 'Poland',
    state: 'Silesian Voivodeship',
  },
  {
    country: 'United States',
    state: 'New Jersey',
  },
  {
    country: 'Poland',
    state: 'Kujawsko-pomorskie',
  },
  {
    country: 'Poland',
    state: 'Lower Silesian Voivodeship',
  },
  {
    country: 'Guatemala',
    state: 'Sacatepéquez',
  },
  {
    country: 'Poland',
    state: 'Warmian-Masurian Voivodeship',
  },
  {
    country: 'Guatemala',
    state: 'Guatemala Department',
  },
  {
    country: 'Spain',
    state: 'Autonomous Community of the Basque Country',
  },
  {
    country: 'Italy',
    state: 'Friuli-Venezia Giulia',
  },
  {
    country: 'United States',
    state: 'Michigan',
  },
  {
    country: 'United States',
    state: 'Nevada',
  },
  {
    country: 'United States',
    state: 'Washington',
  },
  {
    country: 'United States',
    state: 'California',
  },
  {
    country: 'United States',
    state: 'Minnesota',
  },
  {
    country: 'United States',
    state: 'Montana',
  },
  {
    country: 'United States',
    state: 'Delaware',
  },
  {
    country: 'United States',
    state: 'Pennsylvania',
  },
  {
    country: 'United States',
    state: 'Utah',
  },
  {
    country: 'United States',
    state: 'Wyoming',
  },
  {
    country: 'United States',
    state: 'Colorado',
  },
  {
    country: 'United States',
    state: 'Oregon',
  },
  {
    country: 'United States',
    state: 'Ohio',
  },
  {
    country: 'United States',
    state: 'Connecticut',
  },
  {
    country: 'United States',
    state: 'Alabama',
  },
  {
    country: 'United States',
    state: 'Indiana',
  },
  {
    country: 'United States',
    state: 'District of Columbia',
  },
  {
    country: 'United States',
    state: 'North Dakota',
  },
  {
    country: 'United States',
    state: 'Idaho',
  },
  {
    country: 'United States',
    state: 'South Dakota',
  },
  {
    country: 'United States',
    state: 'Tennessee',
  },
  {
    country: 'United States',
    state: 'Kansas',
  },
  {
    country: 'United States',
    state: 'Arizona',
  },
  {
    country: 'United States',
    state: 'Missouri',
  },
  {
    country: 'Spain',
    state: 'Asturias',
  },
  {
    country: 'United Kingdom',
    state: 'Northern Ireland',
  },
  {
    country: 'United States',
    state: 'Nebraska',
  },
  {
    country: 'United States',
    state: 'Kentucky',
  },
  {
    country: 'United States',
    state: 'Georgia',
  },
  {
    country: 'United States',
    state: 'Mississippi',
  },
  {
    country: 'United States',
    state: 'Arkansas',
  },
  {
    country: 'United States',
    state: 'New Mexico',
  },
  {
    country: 'United States',
    state: 'West Virginia',
  },
  {
    country: 'United States',
    state: 'Iowa',
  },
  {
    country: 'United States',
    state: 'Louisiana',
  },
  {
    country: 'Turkey',
    state: 'Adana',
  },
  {
    country: 'Turkey',
    state: 'Adıyaman',
  },
  {
    country: 'Turkey',
    state: 'Afyonkarahisar',
  },
  {
    country: 'Turkey',
    state: 'Amasya',
  },
  {
    country: 'Turkey',
    state: 'Ankara',
  },
  {
    country: 'Turkey',
    state: 'Antalya',
  },
  {
    country: 'Turkey',
    state: 'Artvin',
  },
  {
    country: 'Turkey',
    state: 'Aydın',
  },
  {
    country: 'Turkey',
    state: 'Balıkesir',
  },
  {
    country: 'Turkey',
    state: 'Bilecik',
  },
  {
    country: 'Turkey',
    state: 'Bingöl',
  },
  {
    country: 'Turkey',
    state: 'Bitlis',
  },
  {
    country: 'Turkey',
    state: 'Bolu',
  },
  {
    country: 'Turkey',
    state: 'Burdur',
  },
  {
    country: 'Turkey',
    state: 'Bursa',
  },
  {
    country: 'Turkey',
    state: 'Çanakkale',
  },
  {
    country: 'Turkey',
    state: 'Çankırı',
  },
  {
    country: 'Turkey',
    state: 'Çorum',
  },
  {
    country: 'Turkey',
    state: 'Denizli',
  },
  {
    country: 'Turkey',
    state: 'Diyarbakır',
  },
  {
    country: 'Turkey',
    state: 'Edirne',
  },
  {
    country: 'Turkey',
    state: 'Elazığ',
  },
  {
    country: 'Turkey',
    state: 'Erzincan',
  },
  {
    country: 'Turkey',
    state: 'Erzurum',
  },
  {
    country: 'Turkey',
    state: 'Eskişehir',
  },
  {
    country: 'Turkey',
    state: 'Gaziantep',
  },
  {
    country: 'Turkey',
    state: 'Giresun',
  },
  {
    country: 'Turkey',
    state: 'Gümüşhane',
  },
  {
    country: 'Turkey',
    state: 'Hakkari',
  },
  {
    country: 'Turkey',
    state: 'Hatay',
  },
  {
    country: 'Turkey',
    state: 'Isparta',
  },
  {
    country: 'Turkey',
    state: 'Mersin',
  },
  {
    country: 'Turkey',
    state: 'İstanbul',
  },
  {
    country: 'Turkey',
    state: 'İzmir',
  },
  {
    country: 'Turkey',
    state: 'Kars',
  },
  {
    country: 'Turkey',
    state: 'Kastamonu',
  },
  {
    country: 'Turkey',
    state: 'Kayseri',
  },
  {
    country: 'Turkey',
    state: 'Kırklareli',
  },
  {
    country: 'Turkey',
    state: 'Kırşehir',
  },
  {
    country: 'Turkey',
    state: 'Kocaeli',
  },
  {
    country: 'Turkey',
    state: 'Konya',
  },
  {
    country: 'Turkey',
    state: 'Kütahya',
  },
  {
    country: 'Turkey',
    state: 'Malatya',
  },
  {
    country: 'Turkey',
    state: 'Manisa',
  },
  {
    country: 'Turkey',
    state: 'Kahramanmaraş',
  },
  {
    country: 'Turkey',
    state: 'Mardin',
  },
  {
    country: 'Turkey',
    state: 'Muğla',
  },
  {
    country: 'Turkey',
    state: 'Nevşehir',
  },
  {
    country: 'Turkey',
    state: 'Niğde',
  },
  {
    country: 'Turkey',
    state: 'Ordu',
  },
  {
    country: 'Turkey',
    state: 'Rize',
  },
  {
    country: 'Turkey',
    state: 'Sakarya',
  },
  {
    country: 'Turkey',
    state: 'Samsun',
  },
  {
    country: 'Turkey',
    state: 'Sinop',
  },
  {
    country: 'Turkey',
    state: 'Sivas',
  },
  {
    country: 'Turkey',
    state: 'Tekirdağ',
  },
  {
    country: 'Turkey',
    state: 'Tokat',
  },
  {
    country: 'Turkey',
    state: 'Trabzon',
  },
  {
    country: 'Turkey',
    state: 'Tunceli',
  },
  {
    country: 'Turkey',
    state: 'Şanlıurfa',
  },
  {
    country: 'Turkey',
    state: 'Uşak',
  },
  {
    country: 'Turkey',
    state: 'Van',
  },
  {
    country: 'Turkey',
    state: 'Yozgat',
  },
  {
    country: 'Turkey',
    state: 'Zonguldak',
  },
  {
    country: 'Turkey',
    state: 'Aksaray',
  },
  {
    country: 'Turkey',
    state: 'Bayburt',
  },
  {
    country: 'Turkey',
    state: 'Karaman',
  },
  {
    country: 'Turkey',
    state: 'Kırıkkale',
  },
  {
    country: 'Turkey',
    state: 'Batman',
  },
  {
    country: 'Turkey',
    state: 'Şırnak',
  },
  {
    country: 'Turkey',
    state: 'Bartın',
  },
  {
    country: 'Turkey',
    state: 'Ardahan',
  },
  {
    country: 'Turkey',
    state: 'Iğdır',
  },
  {
    country: 'Turkey',
    state: 'Yalova',
  },
  {
    country: 'Turkey',
    state: 'Karabük',
  },
  {
    country: 'Turkey',
    state: 'Kilis',
  },
  {
    country: 'Turkey',
    state: 'Osmaniye',
  },
  {
    country: 'Turkey',
    state: 'Düzce',
  },
  {
    country: 'Poland',
    state: 'Greater Poland Voivodeship',
  },
  {
    country: 'Poland',
    state: 'Lublin Voivodeship',
  },
  {
    country: 'Netherlands',
    state: 'North Brabant',
  },
  {
    country: 'Poland',
    state: 'Świętokrzyskie Voivodeship',
  },
  {
    country: 'Poland',
    state: 'Subcarpathian Voivodeship',
  },
  {
    country: 'United States',
    state: 'Illinois',
  },
  {
    country: 'Poland',
    state: 'Masovian Voivodeship',
  },
  {
    country: 'Poland',
    state: 'Lubusz Voivodeship',
  },
  {
    country: 'Poland',
    state: 'Pomorskie',
  },
  {
    country: 'Tunisia',
    state: 'Sfax',
  },
  {
    country: 'United States',
    state: 'Wisconsin',
  },
  {
    country: 'Poland',
    state: 'West Pomeranian Voivodeship',
  },
  {
    country: 'Austria',
    state: 'Vienna',
  },
  {
    country: 'India',
    state: 'Tamil Nadu',
  },
  {
    country: 'India',
    state: 'Andhra Pradesh',
  },
  {
    country: 'India',
    state: 'Maharastra',
  },
  {
    country: 'Austria',
    state: 'Upper Austria',
  },
  {
    country: 'South Africa',
    state: 'Eastern Cape',
  },
  {
    country: 'Germany',
    state: 'Bavaria',
  },
  {
    country: 'Denmark',
    state: 'Region Zealand',
  },
  {
    country: 'South Africa',
    state: 'Western Cape',
  },
  {
    country: 'Moldova',
    state: 'Strășeni',
  },
  {
    country: 'Austria',
    state: 'Lower Austria',
  },
  {
    country: 'Austria',
    state: 'Vorarlberg',
  },
  {
    country: 'Austria',
    state: 'Burgenland',
  },
  {
    country: 'Denmark',
    state: 'Southern Denmark',
  },
  {
    country: 'Italy',
    state: 'Sicily',
  },
  {
    country: 'Egypt',
    state: 'Cairo',
  },
  {
    country: 'Egypt',
    state: 'Sadat City',
  },
  {
    country: 'Canada',
    state: 'New Brunswick',
  },
  {
    country: 'United States',
    state: 'New Hampshire',
  },
  {
    country: 'United States',
    state: 'Maine',
  },
  {
    country: 'Germany',
    state: 'North Rhine-Westphalia',
  },
  {
    country: 'Germany',
    state: 'Berlin',
  },
  {
    country: 'Germany',
    state: 'Saarland',
  },
  {
    country: 'United States',
    state: 'New York',
  },
  {
    country: 'Germany',
    state: 'Rhineland-Palatinate',
  },
  {
    country: 'United States',
    state: 'Massachusetts',
  },
  {
    country: 'United States',
    state: 'Vermont',
  },
  {
    country: 'Germany',
    state: 'Saxony',
  },
  {
    country: 'Moldova',
    state: 'Păruceni',
  },
  {
    country: 'Moldova',
    state: 'Calarași District',
  },
  {
    country: 'United Kingdom',
    state: 'England',
  },
  {
    country: 'United Kingdom',
    state: 'Wales',
  },
  {
    country: 'United Kingdom',
    state: 'Cayman Islands',
  },
  {
    country: 'Moldova',
    state: 'Bălceana',
  },
  {
    country: 'Moldova',
    state: 'Vulpești',
  },
  {
    country: 'Sweden',
    state: 'Kalmar',
  },
  {
    country: 'Sweden',
    state: 'Blekinge County',
  },
  {
    country: 'Spain',
    state: 'Galicia',
  },
  {
    country: 'Sweden',
    state: 'Halland County',
  },
  {
    country: 'Sweden',
    state: 'Varmland County',
  },
  {
    country: 'Sweden',
    state: 'Stockholm',
  },
  {
    country: 'Sweden',
    state: 'Skåne County',
  },
  {
    country: 'Sweden',
    state: 'Södermanland County',
  },
  {
    country: 'Sweden',
    state: 'Värmland County',
  },
  {
    country: 'Sweden',
    state: 'Vastra Gotaland',
  },
  {
    country: 'Sweden',
    state: 'Orebro',
  },
  {
    country: 'Belize',
    state: 'Belize City',
  },
  {
    country: 'Belize',
    state: 'Belize',
  },
  {
    country: 'Belize',
    state: 'Santa Cruz',
  },
  {
    country: 'Belize',
    state: 'Orange Walk Town',
  },
  {
    country: 'Belize',
    state: 'Corozal Town',
  },
  {
    country: 'Croatia',
    state: 'Bjelovar-Bilogora County',
  },
  {
    country: 'Croatia',
    state: 'Brod-Posavina County',
  },
  {
    country: 'Croatia',
    state: 'Dubrovnik-Neretva County',
  },
  {
    country: 'Croatia',
    state: 'Istria County',
  },
  {
    country: 'Croatia',
    state: 'Karlovac County',
  },
  {
    country: 'Croatia',
    state: 'Koprivnica-Križevci County',
  },
  {
    country: 'Croatia',
    state: 'Krapina-Zagorje County',
  },
  {
    country: 'Croatia',
    state: 'Lika-Senj County',
  },
  {
    country: 'Croatia',
    state: 'Međimurje County',
  },
  {
    country: 'Croatia',
    state: 'Osijek-Baranja County',
  },
  {
    country: 'Croatia',
    state: 'Požega-Slavonia County',
  },
  {
    country: 'Croatia',
    state: 'Primorje-Gorski Kotar County',
  },
  {
    country: 'Croatia',
    state: 'Šibenik-Knin County',
  },
  {
    country: 'Croatia',
    state: 'Sisak-Moslavina County',
  },
  {
    country: 'Croatia',
    state: 'Split-Dalmatia County',
  },
  {
    country: 'Croatia',
    state: 'Varaždin County',
  },
  {
    country: 'Croatia',
    state: 'Virovitica-Podravina County',
  },
  {
    country: 'Croatia',
    state: 'Vukovar-Syrmia County',
  },
  {
    country: 'Croatia',
    state: 'Zadar County',
  },
  {
    country: 'Croatia',
    state: 'Zagreb County',
  },
  {
    country: 'Croatia',
    state: 'City of Zagreb',
  },
  {
    country: 'Sweden',
    state: 'Kronoberg County',
  },
  {
    country: 'Italy',
    state: 'Abruzzo',
  },
  {
    country: 'Dominican Republic',
    state: 'Distrito Nacional',
  },
  {
    country: 'Sweden',
    state: 'Vastmanland',
  },
  {
    country: 'Italy',
    state: 'Marche',
  },
  {
    country: 'Sweden',
    state: 'Västernorrland County',
  },
  {
    country: 'Sweden',
    state: 'Uppsala County',
  },
  {
    country: 'Sweden',
    state: 'Västerbotten County',
  },
  {
    country: 'Austria',
    state: 'Tyrol',
  },
  {
    country: 'Sweden',
    state: 'Norrbotten County',
  },
  {
    country: 'Philippines',
    state: 'Nueva Ecija',
  },
  {
    country: 'Austria',
    state: 'Carinthia',
  },
  {
    country: 'Philippines',
    state: 'Tarlac',
  },
  {
    country: 'Brazil',
    state: 'Ceará',
  },
  {
    country: 'Brazil',
    state: 'Piauí',
  },
  {
    country: 'Brazil',
    state: 'Bahia',
  },
  {
    country: 'Brazil',
    state: 'Sergipe',
  },
  {
    country: 'Brazil',
    state: 'Goiás',
  },
  {
    country: 'Brazil',
    state: 'Menas Gerais',
  },
  {
    country: 'Brazil',
    state: 'Espírito Santo',
  },
  {
    country: 'Brazil',
    state: 'Rio de Janeiro',
  },
  {
    country: 'Brazil',
    state: 'Mato Grosso',
  },
  {
    country: 'Brazil',
    state: 'Paraná',
  },
  {
    country: 'Brazil',
    state: 'Santa Catartina',
  },
  {
    country: 'Brazil',
    state: 'Rio Grande do Sul',
  },
  {
    country: 'Philippines',
    state: 'Benguet',
  },
  {
    country: 'Brazil',
    state: 'São Paulo',
  },
  {
    country: 'Sweden',
    state: 'Jönköping County',
  },
  {
    country: 'Sweden',
    state: 'Dalarna County',
  },
  {
    country: 'Sweden',
    state: 'Gavleborg',
  },
  {
    country: 'Spain',
    state: 'Balearic Islands',
  },
  {
    country: 'United States',
    state: 'Oklahoma',
  },
  {
    country: 'Germany',
    state: 'Schleswig-Holstein',
  },
  {
    country: 'Germany',
    state: 'Thuringia',
  },
  {
    country: 'Spain',
    state: 'Cantabria',
  },
  {
    country: 'Spain',
    state: 'Santa Cruz de Tenerife',
  },
  {
    country: 'Argentina',
    state: 'Entre Ríos Province',
  },
  {
    country: 'Argentina',
    state: 'San Carlos de Bariloche',
  },
  {
    country: 'Argentina',
    state: 'Mar del Plata',
  },
  {
    country: 'United States',
    state: 'Texas',
  },
  {
    country: 'Germany',
    state: 'Hessen',
  },
  {
    country: 'Denmark',
    state: 'Central Denmark Region',
  },
  {
    country: 'Italy',
    state: 'Apulia',
  },
  {
    country: 'Germany',
    state: 'Brandenburg',
  },
  {
    country: 'Germany',
    state: 'Rheinland-Pfalz',
  },
  {
    country: 'Germany',
    state: 'Nordrhein-Westfalen',
  },
  {
    country: 'Germany',
    state: 'Mecklenburg-Vorpommern',
  },
  {
    country: 'Canada',
    state: 'Quebec',
  },
  {
    country: 'Germany',
    state: 'Saxony-Anhalt',
  },
  {
    country: 'Germany',
    state: 'Baden-Württemberg',
  },
  {
    country: 'Spain',
    state: 'Region of Murcia',
  },
  {
    country: 'Belgium',
    state: 'West Flanders',
  },
  {
    country: 'Belgium',
    state: 'East Flanders',
  },
  {
    country: 'Belgium',
    state: 'Antwerp',
  },
  {
    country: 'Belgium',
    state: 'Limburg',
  },
  {
    country: 'Belgium',
    state: 'Flemish Brabant',
  },
  {
    country: 'Belgium',
    state: 'Hainaut',
  },
  {
    country: 'Belgium',
    state: 'Namur',
  },
  {
    country: 'Belgium',
    state: 'Walloon',
  },
  {
    country: 'Belgium',
    state: 'Liege',
  },
  {
    country: 'Luxembourg',
    state: 'Diekirch District',
  },
  {
    country: 'Luxembourg',
    state: 'Grevenmacher District',
  },
  {
    country: 'Luxembourg',
    state: 'Luxembourg District',
  },
  {
    country: 'Canada',
    state: 'Ontario',
  },
  {
    country: 'Philippines',
    state: 'Cavite',
  },
  {
    country: 'Philippines',
    state: 'Quezon',
  },
  {
    country: 'Philippines',
    state: 'Batangas',
  },
  {
    country: 'Philippines',
    state: 'Camarines Norte',
  },
  {
    country: 'Philippines',
    state: 'Camarines Sur',
  },
  {
    country: 'Philippines',
    state: 'Sorsogon',
  },
  {
    country: 'Philippines',
    state: 'Bataan',
  },
  {
    country: 'Philippines',
    state: 'Bulacan',
  },
  {
    country: 'Philippines',
    state: 'Zambales',
  },
  {
    country: 'Philippines',
    state: 'Pangasinan',
  },
  {
    country: 'Philippines',
    state: 'Ilocos Sur',
  },
  {
    country: 'Philippines',
    state: 'Laguna',
  },
  {
    country: 'Philippines',
    state: 'La Union',
  },
  {
    country: 'Philippines',
    state: 'Rizal',
  },
  {
    country: 'Philippines',
    state: 'Albay',
  },
  {
    country: 'Japan',
    state: 'Hiroshima Prefecture',
  },
  {
    country: 'Philippines',
    state: 'Marinduque',
  },
  {
    country: 'Philippines',
    state: 'Pampanga',
  },
  {
    country: 'Argentina',
    state: 'Buenos Aires',
  },
  {
    country: 'Bahrain',
    state: 'Capital Governorate',
  },
  {
    country: 'Bahrain',
    state: 'Muharraq Governorate',
  },
  {
    country: 'Israel',
    state: 'South District',
  },
  {
    country: 'Taiwan',
    state: 'Hualien County',
  },
  {
    country: 'Taiwan',
    state: 'Tianlun Village',
  },
  {
    country: 'Taiwan',
    state: 'Yunlin County',
  },
  {
    country: 'Taiwan',
    state: 'Hsinchu County',
  },
  {
    country: 'Taiwan',
    state: 'Changhua County',
  },
  {
    country: 'Taiwan',
    state: 'Miaoli County',
  },
  {
    country: 'Taiwan',
    state: 'Hsinchu',
  },
  {
    country: 'Taiwan',
    state: 'Chiayi County',
  },
  {
    country: 'Germany',
    state: 'Lower Saxony',
  },
  {
    country: 'Taiwan',
    state: 'Taoyuan City',
  },
  {
    country: 'New Zealand',
    state: 'Canterbury',
  },
  {
    country: 'Japan',
    state: 'Chiba Prefecture',
  },
  {
    country: 'North Macedonia',
    state: 'Southwestern Region',
  },
  {
    country: 'North Macedonia',
    state: 'Southeastern Region',
  },
  {
    country: 'North Macedonia',
    state: 'Northeastern Region',
  },
  {
    country: 'Bahrain',
    state: 'Southern Governorate',
  },
  {
    country: 'Japan',
    state: 'Ibaraki Prefecture',
  },
  {
    country: 'North Macedonia',
    state: 'Skopje Region',
  },
  {
    country: 'Venezuela',
    state: 'Capital District',
  },
  {
    country: 'Qatar',
    state: 'Al Shahaniya',
  },
  {
    country: 'South Korea',
    state: 'Gwangju',
  },
  {
    country: 'South Korea',
    state: 'Jaeju-Do',
  },
  {
    country: 'South Korea',
    state: 'Daegu',
  },
  {
    country: 'South Korea',
    state: 'Busan',
  },
  {
    country: 'Taiwan',
    state: 'Tainan',
  },
  {
    country: 'Indonesia',
    state: 'North Sumatra',
  },
  {
    country: 'Indonesia',
    state: 'South Sumatra',
  },
  {
    country: 'Indonesia',
    state: 'Riau',
  },
  {
    country: 'Indonesia',
    state: 'Aceh',
  },
  {
    country: 'Indonesia',
    state: 'West Sumatra',
  },
  {
    country: 'Romania',
    state: 'Alba',
  },
  {
    country: 'Romania',
    state: 'Arad',
  },
  {
    country: 'Romania',
    state: 'Argeș',
  },
  {
    country: 'Romania',
    state: 'Bacău',
  },
  {
    country: 'Romania',
    state: 'Bihor',
  },
  {
    country: 'Romania',
    state: 'Bistrița-Năsăud',
  },
  {
    country: 'Romania',
    state: 'Botoșani',
  },
  {
    country: 'Romania',
    state: 'Brașov',
  },
  {
    country: 'Romania',
    state: 'Brăila',
  },
  {
    country: 'Romania',
    state: 'Buzău',
  },
  {
    country: 'Romania',
    state: 'Caraș-Severin',
  },
  {
    country: 'Romania',
    state: 'Călărași',
  },
  {
    country: 'Romania',
    state: 'Cluj',
  },
  {
    country: 'Romania',
    state: 'Constanța',
  },
  {
    country: 'Romania',
    state: 'Covasna',
  },
  {
    country: 'Romania',
    state: 'Dâmbovița',
  },
  {
    country: 'Romania',
    state: 'Dolj',
  },
  {
    country: 'Romania',
    state: 'Galați',
  },
  {
    country: 'Romania',
    state: 'Giurgiu',
  },
  {
    country: 'Romania',
    state: 'Gorj',
  },
  {
    country: 'Romania',
    state: 'Harghita',
  },
  {
    country: 'Romania',
    state: 'Hunedoara',
  },
  {
    country: 'Romania',
    state: 'Ialomița',
  },
  {
    country: 'Romania',
    state: 'Iași',
  },
  {
    country: 'Romania',
    state: 'Ilfov',
  },
  {
    country: 'Romania',
    state: 'Maramureș',
  },
  {
    country: 'Romania',
    state: 'Mehedinți',
  },
  {
    country: 'Romania',
    state: 'Mureș',
  },
  {
    country: 'Romania',
    state: 'Neamț',
  },
  {
    country: 'Romania',
    state: 'Olt',
  },
  {
    country: 'Romania',
    state: 'Prahova',
  },
  {
    country: 'Romania',
    state: 'Satu Mare',
  },
  {
    country: 'Romania',
    state: 'Sălaj',
  },
  {
    country: 'Romania',
    state: 'Sibiu',
  },
  {
    country: 'Romania',
    state: 'Suceava',
  },
  {
    country: 'Romania',
    state: 'Teleorman',
  },
  {
    country: 'Romania',
    state: 'Timiș',
  },
  {
    country: 'Romania',
    state: 'Tulcea',
  },
  {
    country: 'Romania',
    state: 'Vaslui',
  },
  {
    country: 'Romania',
    state: 'Vâlcea',
  },
  {
    country: 'Romania',
    state: 'Vrancea',
  },
  {
    country: 'Romania',
    state: 'Bucharest (București)',
  },
  {
    country: 'Australia',
    state: 'Wreck Bay Village',
  },
  {
    country: 'North Macedonia',
    state: 'Vardar Region',
  },
  {
    country: 'Australia',
    state: 'District of Tuggeranong',
  },
  {
    country: 'South Korea',
    state: 'Chungcheongnam-Do',
  },
  {
    country: 'South Korea',
    state: 'Daejon',
  },
  {
    country: 'Japan',
    state: 'Kanagawa Prefecture',
  },
  {
    country: 'Australia',
    state: 'Victoria',
  },
  {
    country: 'Australia',
    state: 'Nothern Territory',
  },
  {
    country: 'South Korea',
    state: 'Jeollanam-Do',
  },
  {
    country: 'Bosnia and Herzegovina',
    state: 'West Bosnia',
  },
  {
    country: 'Bosnia and Herzegovina',
    state: 'Tuzla',
  },
  {
    country: 'Bosnia and Herzegovina',
    state: 'Banja Luka',
  },
  {
    country: 'Bosnia and Herzegovina',
    state: 'Sarajevo',
  },
  {
    country: 'Bosnia and Herzegovina',
    state: 'Mostar',
  },
  {
    country: 'Australia',
    state: 'South Australia',
  },
  {
    country: 'Australia',
    state: 'Tasmania',
  },
  {
    country: 'South Korea',
    state: 'Kangwon-Do',
  },
  {
    country: 'Australia',
    state: 'Queensland',
  },
  {
    country: 'South Korea',
    state: 'Gyeongsangnam-Do',
  },
  {
    country: 'South Korea',
    state: 'Ongjin-gun',
  },
  {
    country: 'South Korea',
    state: 'Seoul',
  },
  {
    country: 'Australia',
    state: 'New South Wales',
  },
  {
    country: 'South Korea',
    state: 'Hongseong-gun',
  },
  {
    country: 'Australia',
    state: 'Western Australia',
  },
  {
    country: 'New Zealand',
    state: 'Northland Region',
  },
  {
    country: 'Japan',
    state: 'Kyoto Prefecture',
  },
  {
    country: 'New Zealand',
    state: 'Auckland',
  },
  {
    country: 'New Zealand',
    state: 'WKO',
  },
  {
    country: 'Mexico',
    state: 'Quintana Roo',
  },
  {
    country: 'Mexico',
    state: 'Campeche',
  },
  {
    country: 'Mexico',
    state: 'Yucatán',
  },
  {
    country: 'Mexico',
    state: 'Tabasco',
  },
  {
    country: 'Mexico',
    state: 'Veracruz',
  },
  {
    country: 'Mexico',
    state: 'Baja California',
  },
  {
    country: 'Mexico',
    state: 'Sonora',
  },
  {
    country: 'Mexico',
    state: 'Chihuahua',
  },
  {
    country: 'Mexico',
    state: 'Coahuila',
  },
  {
    country: 'Mexico',
    state: 'Durango',
  },
  {
    country: 'Mexico',
    state: 'Sinaloa',
  },
  {
    country: 'Mexico',
    state: 'Nuevo León',
  },
  {
    country: 'Mexico',
    state: 'Tamaulipas',
  },
  {
    country: 'Mexico',
    state: 'Zacatecas',
  },
  {
    country: 'Mexico',
    state: 'Nayarit',
  },
  {
    country: 'Mexico',
    state: 'Jalisco',
  },
  {
    country: 'Mexico',
    state: 'Guanajuato',
  },
  {
    country: 'Mexico',
    state: 'Querêtaro',
  },
  {
    country: 'Mexico',
    state: 'Hidalgo',
  },
  {
    country: 'Mexico',
    state: 'Michocán',
  },
  {
    country: 'Mexico',
    state: 'Mexico City',
  },
  {
    country: 'Mexico',
    state: 'Puebla',
  },
  {
    country: 'Mexico',
    state: 'Tlaxcala',
  },
  {
    country: 'Mexico',
    state: 'Morelos',
  },
  {
    country: 'Mexico',
    state: 'Aguascalientes',
  },
  {
    country: 'Mexico',
    state: 'Querétaro',
  },
  {
    country: 'Georgia',
    state: 'Tbilisi',
  },
  {
    country: 'Georgia',
    state: 'Batumi',
  },
  {
    country: 'Georgia',
    state: 'Samtredia',
  },
  {
    country: 'Georgia',
    state: 'Kutaisi',
  },
  {
    country: 'Georgia',
    state: 'Telavi',
  },
  {
    country: 'Georgia',
    state: 'Rustavi',
  },
  {
    country: 'Georgia',
    state: 'Vardzia',
  },
  {
    country: 'Georgia',
    state: 'Dusheti Municipality',
  },
  {
    country: 'Vietnam',
    state: 'Hồ Chí Minh City',
  },
  {
    country: 'South Korea',
    state: 'Goesan-gun',
  },
  {
    country: 'India',
    state: 'Punjab',
  },
  {
    country: 'Bosnia and Herzegovina',
    state: 'SRP',
  },
  {
    country: 'Germany',
    state: 'Landkreis Eichstätt',
  },
  {
    country: 'India',
    state: 'Uttar Pradesh',
  },
  {
    country: 'India',
    state: 'Delhi',
  },
  {
    country: 'India',
    state: 'Gujarat',
  },
  {
    country: 'India',
    state: 'Rajasthan',
  },
  {
    country: 'India',
    state: 'Kerala',
  },
  {
    country: 'India',
    state: 'Karnataka',
  },
  {
    country: 'India',
    state: 'Tamil Nadu',
  },
  {
    country: 'India',
    state: 'West Bengal',
  },
  {
    country: 'Bangladesh',
    state: 'Dhaka',
  },
  {
    country: 'Bangladesh',
    state: 'Chattogram',
  },
  {
    country: 'Thailand',
    state: 'Chiang Rai',
  },
  {
    country: 'Thailand',
    state: 'Phayao',
  },
  {
    country: 'Thailand',
    state: 'Chiang Dao',
  },
  {
    country: 'Thailand',
    state: 'Chinag Mai',
  },
  {
    country: 'Thailand',
    state: 'Mae Chaem',
  },
  {
    country: 'Thailand',
    state: 'Lamphun',
  },
  {
    country: 'Thailand',
    state: 'Mae Hong Son',
  },
  {
    country: 'Thailand',
    state: 'Tak',
  },
  {
    country: 'Thailand',
    state: 'Kamphaeng Phet',
  },
  {
    country: 'Thailand',
    state: 'Phitsanulok',
  },
  {
    country: 'Thailand',
    state: 'Phichit',
  },
  {
    country: 'Thailand',
    state: 'Nakhon Sawan',
  },
  {
    country: 'Thailand',
    state: 'Lan Sak',
  },
  {
    country: 'Thailand',
    state: 'Uthai Thani',
  },
  {
    country: 'Thailand',
    state: 'Suphan Buri',
  },
  {
    country: 'Thailand',
    state: 'Kanchanaburi',
  },
  {
    country: 'Thailand',
    state: 'Ratchaburi',
  },
  {
    country: 'Thailand',
    state: 'Phetchabun',
  },
  {
    country: 'Thailand',
    state: 'Nakhon Pathom',
  },
  {
    country: 'Thailand',
    state: 'Phetchaburi',
  },
  {
    country: 'Thailand',
    state: 'Smaut Prakan',
  },
  {
    country: 'Thailand',
    state: 'Bangkok',
  },
  {
    country: 'Thailand',
    state: 'Nonthaburi',
  },
  {
    country: 'Thailand',
    state: 'Samut Sakhon',
  },
  {
    country: 'Thailand',
    state: 'Samut Songkhram',
  },
  {
    country: 'Thailand',
    state: 'Singburi',
  },
  {
    country: 'Thailand',
    state: 'Ang-Thong',
  },
  {
    country: 'Thailand',
    state: 'Ayutthaya',
  },
  {
    country: 'Thailand',
    state: 'Pathum-Thani',
  },
  {
    country: 'Thailand',
    state: 'Chainat',
  },
  {
    country: 'Thailand',
    state: 'Phetchabun',
  },
  {
    country: 'Thailand',
    state: 'Lopburi',
  },
  {
    country: 'Thailand',
    state: 'Saraburi',
  },
  {
    country: 'Thailand',
    state: 'Nakhon-Nayok',
  },
  {
    country: 'Thailand',
    state: 'Prachinburi',
  },
  {
    country: 'Thailand',
    state: 'Chaochoengsao',
  },
  {
    country: 'Thailand',
    state: 'Chonburi',
  },
  {
    country: 'Thailand',
    state: 'Rayong',
  },
  {
    country: 'Thailand',
    state: 'Chiayaphum',
  },
  {
    country: 'Thailand',
    state: 'Nakhon-Ratchasima',
  },
  {
    country: 'Thailand',
    state: 'Sa Kaew',
  },
  {
    country: 'Thailand',
    state: 'Chanthaburi',
  },
  {
    country: 'Thailand',
    state: 'Trat',
  },
  {
    country: 'Thailand',
    state: 'Nongbualamphu',
  },
  {
    country: 'Thailand',
    state: 'Khon Kaen',
  },
  {
    country: 'Thailand',
    state: 'Buriram',
  },
  {
    country: 'Thailand',
    state: 'Nong Khai',
  },
  {
    country: 'Thailand',
    state: 'Udon Thani',
  },
  {
    country: 'Thailand',
    state: 'Kalasin',
  },
  {
    country: 'Thailand',
    state: 'Maha Sarakham',
  },
  {
    country: 'Thailand',
    state: 'Surin',
  },
  {
    country: 'Thailand',
    state: 'Roi Et',
  },
  {
    country: 'Thailand',
    state: 'Bueng Kan',
  },
  {
    country: 'Thailand',
    state: 'Nakhon Phanom',
  },
  {
    country: 'Thailand',
    state: 'Mukdaham',
  },
  {
    country: 'Thailand',
    state: 'Yasothon',
  },
  {
    country: 'Thailand',
    state: 'Ubon-Ratchathani',
  },
  {
    country: 'Thailand',
    state: 'Sisaket',
  },
  {
    country: 'Thailand',
    state: 'Prachuap Khiri Khan',
  },
  {
    country: 'Thailand',
    state: 'Chumphon',
  },
  {
    country: 'Thailand',
    state: 'Ranong',
  },
  {
    country: 'Thailand',
    state: 'Surat Thani',
  },
  {
    country: 'Thailand',
    state: 'Phang Nga',
  },
  {
    country: 'Thailand',
    state: 'Phuket',
  },
  {
    country: 'Thailand',
    state: 'Krabi',
  },
  {
    country: 'Thailand',
    state: 'Nakhon Si Thammarat',
  },
  {
    country: 'Thailand',
    state: 'Trang',
  },
  {
    country: 'Thailand',
    state: 'Phatthalung',
  },
  {
    country: 'Thailand',
    state: 'Satun',
  },
  {
    country: 'Thailand',
    state: 'Songkhla',
  },
  {
    country: 'Thailand',
    state: 'Pattani',
  },
  {
    country: 'Thailand',
    state: 'Yala',
  },
  {
    country: 'Thailand',
    state: 'Narathiwat',
  },
  {
    country: 'Vietnam',
    state: 'Hà Nội',
  },
  {
    country: 'Vietnam',
    state: 'Hải Dương City',
  },
  {
    country: 'Vietnam',
    state: 'Ân Thi District',
  },
  {
    country: 'Japan',
    state: 'Taku',
  },
  {
    country: 'Japan',
    state: 'Kagoshima County',
  },
  {
    country: 'Angola',
    state: 'Municipality of Quiçama',
  },
  {
    country: 'Japan',
    state: 'Utsunomiya',
  },
  {
    country: 'New Zealand',
    state: 'BOP',
  },
  {
    country: 'Italy',
    state: 'CAL',
  },
  {
    country: 'Guernsey',
    state: 'St Peter Port',
  },
  {
    country: 'Japan',
    state: 'Koriyama',
  },
  {
    country: 'Bulgaria',
    state: 'Blagoevgrad',
  },
  {
    country: 'Bulgaria',
    state: 'Burgas',
  },
  {
    country: 'Bulgaria',
    state: 'Dobrich',
  },
  {
    country: 'Bulgaria',
    state: 'Gabrovo',
  },
  {
    country: 'Bulgaria',
    state: 'Haskovo',
  },
  {
    country: 'Bulgaria',
    state: 'Kardzhali',
  },
  {
    country: 'Bulgaria',
    state: 'Kyustendil',
  },
  {
    country: 'Bulgaria',
    state: 'Lovech',
  },
  {
    country: 'Bulgaria',
    state: 'Montana',
  },
  {
    country: 'Bulgaria',
    state: 'Pazardzhik',
  },
  {
    country: 'Bulgaria',
    state: 'Pernik',
  },
  {
    country: 'Bulgaria',
    state: 'Pleven',
  },
  {
    country: 'Bulgaria',
    state: 'Plovdiv',
  },
  {
    country: 'Bulgaria',
    state: 'Razgrad',
  },
  {
    country: 'Bulgaria',
    state: 'Ruse',
  },
  {
    country: 'Bulgaria',
    state: 'Silistra',
  },
  {
    country: 'Bulgaria',
    state: 'Sliven',
  },
  {
    country: 'Bulgaria',
    state: 'Smolyan',
  },
  {
    country: 'Bulgaria',
    state: 'Sofia City Province',
  },
  {
    country: 'Bulgaria',
    state: 'Sofia Province',
  },
  {
    country: 'Bulgaria',
    state: 'Stara Zagora',
  },
  {
    country: 'Bulgaria',
    state: 'Targovishte',
  },
  {
    country: 'Bulgaria',
    state: 'Varna',
  },
  {
    country: 'Bulgaria',
    state: 'Veliko Tarnovo',
  },
  {
    country: 'Bulgaria',
    state: 'Vidin',
  },
  {
    country: 'Bulgaria',
    state: 'Vratsa',
  },
  {
    country: 'Bulgaria',
    state: 'Yambol',
  },
  {
    country: 'India',
    state: 'Rajasthan',
  },
  {
    country: 'Moldova',
    state: 'Dubasari District (Transnistria)',
  },
  {
    country: 'Moldova',
    state: 'Chișinau',
  },
  {
    country: 'Moldova',
    state: 'Costești',
  },
  {
    country: 'Uruguay',
    state: 'RN',
  },
  {
    country: 'Uruguay',
    state: 'CO',
  },
  {
    country: 'Uruguay',
    state: 'SO',
  },
  {
    country: 'India',
    state: 'Kerala',
  },
  {
    country: 'India',
    state: 'Madhya Pradesh',
  },
  {
    country: 'Uruguay',
    state: 'FS',
  },
  {
    country: 'Uruguay',
    state: 'SJ',
  },
  {
    country: 'New Zealand',
    state: 'Selwyn District',
  },
  {
    country: 'New Zealand',
    state: 'Rangitikei District',
  },
  {
    country: 'Uruguay',
    state: 'CL',
  },
  {
    country: 'Uruguay',
    state: 'FD',
  },
  {
    country: 'Uruguay',
    state: 'TT',
  },
  {
    country: 'New Zealand',
    state: 'WGN',
  },
  {
    country: 'Uruguay',
    state: 'LA',
  },
  {
    country: 'Uruguay',
    state: 'MA',
  },
  {
    country: 'Uruguay',
    state: 'MO',
  },
  {
    country: 'Uruguay',
    state: 'PA',
  },
  {
    country: 'Latvia',
    state: 'Kurzeme',
  },
  {
    country: 'Latvia',
    state: 'Zemgale',
  },
  {
    country: 'Latvia',
    state: 'Vidzeme',
  },
  {
    country: 'Latvia',
    state: 'Riga',
  },
  {
    country: 'Latvia',
    state: 'Latgale',
  },
  {
    country: 'Latvia',
    state: 'Pieriga',
  },
  {
    country: 'Uruguay',
    state: 'CA',
  },
  {
    country: 'Uruguay',
    state: 'DU',
  },
  {
    country: 'Switzerland',
    state: 'Aargau',
  },
  {
    country: 'Switzerland',
    state: 'Appenzell Ausserrhoden',
  },
  {
    country: 'Switzerland',
    state: 'Appenzell Innerrhoden',
  },
  {
    country: 'Switzerland',
    state: 'Basel-Landschaft',
  },
  {
    country: 'Switzerland',
    state: 'Basel-Stadt',
  },
  {
    country: 'Switzerland',
    state: 'Bern',
  },
  {
    country: 'Switzerland',
    state: 'Fribourg',
  },
  {
    country: 'Switzerland',
    state: 'Geneva',
  },
  {
    country: 'Switzerland',
    state: 'Glarus',
  },
  {
    country: 'Switzerland',
    state: 'Graubünden',
  },
  {
    country: 'Switzerland',
    state: 'Jura',
  },
  {
    country: 'Switzerland',
    state: 'Lucerne',
  },
  {
    country: 'Switzerland',
    state: 'Neuchâtel',
  },
  {
    country: 'Switzerland',
    state: 'Nidwalden',
  },
  {
    country: 'Switzerland',
    state: 'Obwalden',
  },
  {
    country: 'Switzerland',
    state: 'Schaffhausen',
  },
  {
    country: 'Switzerland',
    state: 'Schwyz',
  },
  {
    country: 'Switzerland',
    state: 'Solothurn',
  },
  {
    country: 'Switzerland',
    state: 'St. Gallen',
  },
  {
    country: 'Switzerland',
    state: 'Thurgau',
  },
  {
    country: 'Switzerland',
    state: 'Ticino',
  },
  {
    country: 'Switzerland',
    state: 'Uri',
  },
  {
    country: 'Switzerland',
    state: 'Valais',
  },
  {
    country: 'Switzerland',
    state: 'Vaud',
  },
  {
    country: 'Switzerland',
    state: 'Zug',
  },
  {
    country: 'Switzerland',
    state: 'Zurich',
  },
  {
    country: 'Philippines',
    state: 'Mulao',
  },
  {
    country: 'Taiwan',
    state: 'New Taipei City',
  },
  {
    country: 'Japan',
    state: 'Fukuoka Prefecture',
  },
  {
    country: 'Japan',
    state: 'Shibukawa',
  },
  {
    country: 'India',
    state: 'HR',
  },
  {
    country: 'India',
    state: 'WB',
  },
  {
    country: 'Australia',
    state: 'Barkly Region',
  },
  {
    country: 'Japan',
    state: 'Hiki County',
  },
  {
    country: 'Palestinian Territory',
    state: 'Area C',
  },
  {
    country: 'Costa Rica',
    state: 'San José',
  },
  {
    country: 'Costa Rica',
    state: 'Limón',
  },
  {
    country: 'Costa Rica',
    state: 'Cartago',
  },
  {
    country: 'Costa Rica',
    state: 'Puntarenas',
  },
  {
    country: 'Costa Rica',
    state: 'Guanacaste',
  },
  {
    country: 'Costa Rica',
    state: 'Alajuela',
  },
  {
    country: 'Costa Rica',
    state: 'Heredia',
  },
  {
    country: 'India',
    state: 'Telangana',
  },
  {
    country: 'India',
    state: 'Chhattisgarh',
  },
  {
    country: 'India',
    state: 'Jharkhand',
  },
  {
    country: 'Japan',
    state: 'Miyazaki',
  },
  {
    country: 'Japan',
    state: 'Kimotsuki County',
  },
  {
    country: 'Japan',
    state: 'Kagoshima Prefecture',
  },
  {
    country: 'Japan',
    state: 'Kumamoto Prefecture',
  },
  {
    country: 'Japan',
    state: 'Tottori Prefecture',
  },
  {
    country: 'Iceland',
    state: 'Capital Region',
  },
  {
    country: 'Iceland',
    state: 'Southern Peninsula',
  },
  {
    country: 'Iceland',
    state: 'Western Region',
  },
  {
    country: 'Iceland',
    state: 'Westfjords',
  },
  {
    country: 'Iceland',
    state: 'Northwestern Region	',
  },
  {
    country: 'Iceland',
    state: 'Northeastern Region	',
  },
  {
    country: 'Iceland',
    state: 'Eastern Region',
  },
  {
    country: 'Iceland',
    state: 'Southern Region',
  },
  {
    country: 'Poland',
    state: 'Krapkowice',
  },
  {
    country: 'Albania',
    state: 'Elbasan County',
  },
  {
    country: 'Albania',
    state: 'Lezhe County',
  },
  {
    country: 'Albania',
    state: 'Kukës County',
  },
  {
    country: 'Albania',
    state: 'Durrës County',
  },
  {
    country: 'Albania',
    state: 'Fier County',
  },
  {
    country: 'Albania',
    state: 'Vlorë County',
  },
  {
    country: 'Albania',
    state: 'Gjirokastra County',
  },
  {
    country: 'Albania',
    state: 'Berat County',
  },
  {
    country: 'Guyana',
    state: 'DE',
  },
  {
    country: 'Spain',
    state: 'Área metropolitana de Madrid y Corredor del Henares',
  },
  {
    country: 'Spain',
    state: 'Las Palmas de Gran Canaria',
  },
  {
    country: 'Spain',
    state: 'Antigua',
  },
  {
    country: 'Spain',
    state: 'Arrecife',
  },
  {
    country: 'Gibraltar',
    state: 'Gibraltar',
  },
  {
    country: 'Panama',
    state: 'Distrito Penonomé',
  },
  {
    country: 'Panama',
    state: 'Distrito Capira',
  },
  {
    country: 'Panama',
    state: 'Panama',
  },
  {
    country: 'Cyprus',
    state: 'Famagusta',
  },
  {
    country: 'Cyprus',
    state: 'Limassol',
  },
  {
    country: 'Cyprus',
    state: 'Nicosia',
  },
  {
    country: 'Cyprus',
    state: 'Larnaca',
  },
  {
    country: 'Cyprus',
    state: 'Kyrenia',
  },
  {
    country: 'Cyprus',
    state: 'Paphos',
  },
  {
    country: 'Indonesia',
    state: 'Gunung Kidul Regency',
  },
  {
    country: 'South Africa',
    state: 'EC',
  },
  {
    country: 'South Africa',
    state: 'Durban',
  },
  {
    country: 'South Africa',
    state: 'Ladysmith',
  },
  {
    country: 'South Africa',
    state: 'Pietermaritzburg',
  },
  {
    country: 'South Africa',
    state: 'Ballito',
  },
  {
    country: 'South Africa',
    state: 'Rustenburg',
  },
  {
    country: 'South Africa',
    state: 'Witbank',
  },
  {
    country: 'South Africa',
    state: 'Tembisa',
  },
  {
    country: 'South Africa',
    state: 'Vereeniging',
  },
  {
    country: 'South Africa',
    state: 'Reitz',
  },
  {
    country: 'South Africa',
    state: 'Bethlehem',
  },
  {
    country: 'South Africa',
    state: 'Parys',
  },
  {
    country: 'South Africa',
    state: 'Vryburg',
  },
  {
    country: 'South Africa',
    state: 'Struizendam',
  },
  {
    country: 'Albania',
    state: 'Shkodër County',
  },
  {
    country: 'Greece',
    state: 'Rethymno Regional Unit',
  },
  {
    country: 'Greece',
    state: 'Crete',
  },
  {
    country: 'Greece',
    state: 'North Aegean',
  },
  {
    country: 'Greece',
    state: 'Peloponnese',
  },
  {
    country: 'Greece',
    state: 'South Aegean',
  },
  {
    country: 'Malta',
    state: 'Northern Region',
  },
  {
    country: 'Malta',
    state: 'Southern Region',
  },
  {
    country: 'Malta',
    state: 'Central Region',
  },
  {
    country: 'Malta',
    state: 'Gozo and Comino Region',
  },
  {
    country: 'Malta',
    state: 'Western Region',
  },
  {
    country: 'United States',
    state: 'PR',
  },
  {
    country: 'United States',
    state: 'Guam',
  },
  {
    country: 'United States',
    state: 'Northern Mariana Islands',
  },
  {
    country: 'United States',
    state: 'Maryland',
  },
  {
    country: 'Greece',
    state: 'Grevena Regional Unit',
  },
  {
    country: 'Greece',
    state: 'Eastern Macedonia and Thrace',
  },
  {
    country: 'Greece',
    state: 'Kavala Regional Unit',
  },
  {
    country: 'Greece',
    state: 'Central Macedonia',
  },
  {
    country: 'Greece',
    state: 'Western Macedonia',
  },
  {
    country: 'Greece',
    state: 'Epirus',
  },
  {
    country: 'Greece',
    state: 'Attica',
  },
  {
    country: 'Greece',
    state: 'Central Greece',
  },
  {
    country: 'Greece',
    state: 'Thessaly',
  },
  {
    country: 'Greece',
    state: 'Monastic Community of Mount Athos',
  },
  {
    country: 'Greece',
    state: 'Western Greece',
  },
  {
    country: 'Greece',
    state: 'Ionian Islands',
  },
  {
    country: 'New Zealand',
    state: 'TAS',
  },
  {
    country: 'New Zealand',
    state: 'MBH',
  },
  {
    country: 'Greece',
    state: 'Samos Regional Unit',
  },
  {
    country: 'Japan',
    state: 'Yamaguchi Prefecture',
  },
  {
    country: 'Oman',
    state: 'Sohar',
  },
  {
    country: 'Bangladesh',
    state: 'Savar Subdistrict',
  },
  {
    country: 'Greece',
    state: 'Elis Regional Unit',
  },
  {
    country: 'Armenia',
    state: 'Talin region',
  },
  {
    country: 'Malaysia',
    state: 'Johor',
  },
  {
    country: 'Malaysia',
    state: 'Kedah',
  },
  {
    country: 'Malaysia',
    state: 'Kelantan',
  },
  {
    country: 'Malaysia',
    state: 'Malacca',
  },
  {
    country: 'Malaysia',
    state: 'Negeri Sembilan',
  },
  {
    country: 'Malaysia',
    state: 'Pahang',
  },
  {
    country: 'Malaysia',
    state: 'Penang',
  },
  {
    country: 'Malaysia',
    state: 'Perak',
  },
  {
    country: 'Malaysia',
    state: 'Perlis',
  },
  {
    country: 'Malaysia',
    state: 'Sabah',
  },
  {
    country: 'Malaysia',
    state: 'Sarawak',
  },
  {
    country: 'Malaysia',
    state: 'Selangor',
  },
  {
    country: 'Malaysia',
    state: 'Terengganu',
  },
  {
    country: 'Malaysia',
    state: 'Kuala Lumpur',
  },
  {
    country: 'Malaysia',
    state: 'Putrajaya',
  },
  {
    country: 'Brunei',
    state: 'BM',
  },
  {
    country: 'Japan',
    state: 'Shizuoka',
  },
  {
    country: 'Japan',
    state: 'Sorachi County',
  },
  {
    country: 'Japan',
    state: 'Iwate Prefecture',
  },
  {
    country: 'Japan',
    state: 'Akita',
  },
  {
    country: 'Japan',
    state: 'Toyama',
  },
  {
    country: 'Japan',
    state: 'Higashimatsushima',
  },
  {
    country: 'Japan',
    state: 'Okayama Prefecture',
  },
  {
    country: 'Japan',
    state: 'Ishikawa Prefecture',
  },
  {
    country: 'Oman',
    state: 'Nizwa',
  },
  {
    country: 'United Arab Emirates',
    state: 'Fujairah',
  },
  {
    country: 'United Arab Emirates',
    state: 'Dubai',
  },
  {
    country: 'United Arab Emirates',
    state: 'Umm Al Quwain',
  },
  {
    country: 'United Arab Emirates',
    state: 'Sharjah',
  },
  {
    country: 'Oman',
    state: 'Jaalan Bani Bu Ali',
  },
  {
    country: 'United Arab Emirates',
    state: 'Ras al Khaimah',
  },
  {
    country: 'Japan',
    state: 'Yamagata Prefecture',
  },
  {
    country: 'Nigeria',
    state: 'Itesiwaju',
  },
  {
    country: 'Nigeria',
    state: 'Lagos',
  },
  {
    country: 'Nigeria',
    state: 'Abuja',
  },
  {
    country: 'United Arab Emirates',
    state: 'Abu Dhabi',
  },
  {
    country: 'Nigeria',
    state: 'Municipal Area Council',
  },
  {
    country: 'United Arab Emirates',
    state: 'Ajman',
  },
  {
    country: 'Nigeria',
    state: 'Ikorodu',
  },
  {
    country: 'Saudi Arabia',
    state: 'Al Quwayiyah',
  },
  {
    country: 'Saudi Arabia',
    state: 'Medina',
  },
  {
    country: 'Saudi Arabia',
    state: 'Makkah',
  },
  {
    country: 'Japan',
    state: 'Kita County',
  },
  {
    country: 'Saudi Arabia',
    state: 'Baysh',
  },
  {
    country: 'Saudi Arabia',
    state: 'Bahah',
  },
  {
    country: 'Saudi Arabia',
    state: 'Asir',
  },
  {
    country: 'Saudi Arabia',
    state: 'Eastern Province',
  },
  {
    country: 'Saudi Arabia',
    state: 'Riyadh',
  },
  {
    country: 'Saudi Arabia',
    state: 'Jizan',
  },
  {
    country: 'Saudi Arabia',
    state: 'Al Aqiq',
  },
  {
    country: 'Saudi Arabia',
    state: 'Khaybar',
  },
  {
    country: 'Japan',
    state: 'Shiojiri',
  },
  {
    country: 'Japan',
    state: 'Niigata Prefecture',
  },
  {
    country: 'Nigeria',
    state: 'Obafemi Owode',
  },
  {
    country: 'Japan',
    state: 'Yamanashi Prefecture',
  },
  {
    country: 'Greece',
    state: 'Regional Unit of Magnesia',
  },
  {
    country: 'Oman',
    state: 'Muscat',
  },
  {
    country: 'Portugal',
    state: 'Aveiro',
  },
  {
    country: 'Portugal',
    state: 'Beja',
  },
  {
    country: 'Portugal',
    state: 'Braga',
  },
  {
    country: 'Portugal',
    state: 'Bragança',
  },
  {
    country: 'Portugal',
    state: 'Castelo Branco',
  },
  {
    country: 'Portugal',
    state: 'Coimbra',
  },
  {
    country: 'Portugal',
    state: 'Évora',
  },
  {
    country: 'Portugal',
    state: 'Faro',
  },
  {
    country: 'Portugal',
    state: 'Guarda',
  },
  {
    country: 'Portugal',
    state: 'Leiria',
  },
  {
    country: 'Portugal',
    state: 'Lisbon',
  },
  {
    country: 'Portugal',
    state: 'Portalegre',
  },
  {
    country: 'Portugal',
    state: 'Porto',
  },
  {
    country: 'Portugal',
    state: 'Santarém',
  },
  {
    country: 'Portugal',
    state: 'Setúbal',
  },
  {
    country: 'Portugal',
    state: 'Viana do Castelo',
  },
  {
    country: 'Portugal',
    state: 'Vila Real',
  },
  {
    country: 'Portugal',
    state: 'Viseu',
  },
  {
    country: 'Vatican City',
    state: 'Vatican City',
  },
  {
    country: 'Saint Lucia',
    state: 'Castries',
  },
  {
    country: 'Saint Lucia',
    state: 'Anse la Raye',
  },
  {
    country: 'Saint Lucia',
    state: 'Canaries',
  },
  {
    country: 'Saint Lucia',
    state: 'Souffriére',
  },
  {
    country: 'Saint Lucia',
    state: 'Choisel',
  },
  {
    country: 'Kenya',
    state: 'Gatundu',
  },
  {
    country: 'Kenya',
    state: 'Nairobi',
  },
  {
    country: 'Mauritius',
    state: 'Port Louis',
  },
  {
    country: 'Mauritius',
    state: 'Vacoas / Phoenix',
  },
  {
    country: 'Saudi Arabia',
    state: 'Khamis Mushayt',
  },
  {
    country: 'Mauritius',
    state: "Poudre D'Or Hamlet",
  },
  {
    country: 'Mauritius',
    state: 'Tamarin',
  },
  {
    country: 'Mauritius',
    state: 'New Grove',
  },
  {
    country: 'Mauritius',
    state: 'Queen Victoria',
  },
  {
    country: 'Mauritius',
    state: 'Pamplemousses',
  },
  {
    country: 'Mauritius',
    state: 'Dubreuil',
  },
  {
    country: 'Dominican Republic',
    state: 'San Cristóbal',
  },
  {
    country: 'Dominican Republic',
    state: 'Quisqueya',
  },
  {
    country: 'Dominican Republic',
    state: 'Nagua',
  },
  {
    country: 'Dominican Republic',
    state: 'Higüey',
  },
  {
    country: 'Dominican Republic',
    state: 'Santo Domingo Norte',
  },
  {
    country: 'Dominican Republic',
    state: 'Monte Plata',
  },
  {
    country: 'Dominican Republic',
    state: 'El Factor',
  },
  {
    country: 'Dominican Republic',
    state: 'Villa Hermosa',
  },
  {
    country: 'Indonesia',
    state: 'Sumenep',
  },
  {
    country: 'Indonesia',
    state: 'Jakarta',
  },
  {
    country: 'Italy',
    state: 'Oristano',
  },
  {
    country: 'Saudi Arabia',
    state: 'Missan',
  },
  {
    country: 'Saudi Arabia',
    state: 'Al Ahsa Governorate',
  },
  {
    country: 'Japan',
    state: 'Yame',
  },
  {
    country: 'Japan',
    state: 'Wakayama Prefecture',
  },
  {
    country: 'Japan',
    state: 'Kyoto',
  },
  {
    country: 'Japan',
    state: 'Yoshino County',
  },
  {
    country: 'Japan',
    state: 'Yao',
  },
  {
    country: 'Japan',
    state: 'Takamatsu-shi',
  },
  {
    country: 'Japan',
    state: 'Kudamatsu',
  },
  {
    country: 'Japan',
    state: 'Izumisano',
  },
  {
    country: 'Japan',
    state: 'Hiroshima',
  },
  {
    country: 'Japan',
    state: 'Okayama',
  },
  {
    country: 'Japan',
    state: 'Tsuyama',
  },
  {
    country: 'Japan',
    state: 'Himeji',
  },
  {
    country: 'Japan',
    state: 'Shimane Prefecture',
  },
  {
    country: 'Japan',
    state: 'Tohaku County',
  },
  {
    country: 'Japan',
    state: 'Sera County',
  },
  {
    country: 'Japan',
    state: 'Nagasaki Prefecture',
  },
  {
    country: 'Japan',
    state: 'Toyooka',
  },
  {
    country: 'Japan',
    state: 'Aichi Prefecture',
  },
  {
    country: 'Japan',
    state: 'Funai County',
  },
  {
    country: 'Japan',
    state: 'Iga',
  },
  {
    country: 'Japan',
    state: 'Toyohashi',
  },
  {
    country: 'Japan',
    state: 'Matsusaka',
  },
  {
    country: 'Japan',
    state: 'Shizuoka Prefecture',
  },
  {
    country: 'Japan',
    state: 'Hiratsuka',
  },
  {
    country: 'Japan',
    state: 'Chiba Prefecture',
  },
  {
    country: 'Japan',
    state: 'Chiba Prefecture',
  },
  {
    country: 'Japan',
    state: 'Ome',
  },
  {
    country: 'Japan',
    state: 'Yamanashi Prefecture',
  },
  {
    country: 'Japan',
    state: 'Tako',
  },
  {
    country: 'Japan',
    state: 'Naka County',
  },
  {
    country: 'Japan',
    state: 'Miyake Subprefecture',
  },
  {
    country: 'Japan',
    state: 'Mito',
  },
  {
    country: 'Serbia',
    state: 'Belgrade (City District)',
  },
  {
    country: 'Serbia',
    state: 'Bor District',
  },
  {
    country: 'Serbia',
    state: 'Braničevo District',
  },
  {
    country: 'Serbia',
    state: 'Jablanica District',
  },
  {
    country: 'Serbia',
    state: 'Kolubara District',
  },
  {
    country: 'Serbia',
    state: 'Mačva District',
  },
  {
    country: 'Serbia',
    state: 'Moravica District',
  },
  {
    country: 'Serbia',
    state: 'Nišava District',
  },
  {
    country: 'Serbia',
    state: 'North Bačka District',
  },
  {
    country: 'Serbia',
    state: 'North Banat District',
  },
  {
    country: 'Serbia',
    state: 'Pčinja District',
  },
  {
    country: 'Serbia',
    state: 'Pirot District',
  },
  {
    country: 'Serbia',
    state: 'Podunavlje District',
  },
  {
    country: 'Serbia',
    state: 'Pomoravlje District',
  },
  {
    country: 'Serbia',
    state: 'Rasina District',
  },
  {
    country: 'Serbia',
    state: 'Raška District',
  },
  {
    country: 'Serbia',
    state: 'South Bačka District',
  },
  {
    country: 'Serbia',
    state: 'South Banat District',
  },
  {
    country: 'Serbia',
    state: 'Srem District',
  },
  {
    country: 'Serbia',
    state: 'Šumadija District',
  },
  {
    country: 'Serbia',
    state: 'Toplica District',
  },
  {
    country: 'Serbia',
    state: 'West Bačka District',
  },
  {
    country: 'Serbia',
    state: 'Zaječar District',
  },
  {
    country: 'Serbia',
    state: 'Zlatibor District',
  },
  {
    country: 'Serbia',
    state: 'Central Banat District',
  },
  {
    country: 'Serbia',
    state: 'Kosovo-Pomoravlje District',
  },
  {
    country: 'Serbia',
    state: 'Southern and Eastern Serbia District',
  },
  {
    country: 'Serbia',
    state: 'Kosovo-Metohija District',
  },
  {
    country: 'Serbia',
    state: 'Raška District',
  },
  {
    country: 'Lebanon',
    state: 'Jbayl',
  },
  {
    country: 'Paraguay',
    state: 'Asunción',
  },
  {
    country: 'Qatar',
    state: 'Al Ebaib/Al Ebb/Al Kheesa/Lusail/Umm Qarn',
  },
  {
    country: 'Norway',
    state: 'Midt-Telemark',
  },
  {
    country: 'Norway',
    state: 'Viken',
  },
  {
    country: 'Norway',
    state: 'Vestfold of Telemark',
  },
  {
    country: 'Norway',
    state: 'Agder',
  },
  {
    country: 'United States',
    state: 'Rhode Island',
  },
  {
    country: 'Norway',
    state: 'Gausdal',
  },
  {
    country: 'Norway',
    state: 'Vik',
  },
  {
    country: 'France',
    state: 'Hautes-de-France',
  },
  {
    country: 'France',
    state: 'Normandie',
  },
  {
    country: 'France',
    state: 'île-de-France',
  },
  {
    country: 'France',
    state: 'Grand Est',
  },
  {
    country: 'France',
    state: 'Bretange',
  },
  {
    country: 'France',
    state: 'Pays de la Loire',
  },
  {
    country: 'France',
    state: 'Centre Val de Loire',
  },
  {
    country: 'France',
    state: 'Bourgogne Franche-Comte',
  },
  {
    country: 'France',
    state: 'Nouvelle',
  },
  {
    country: 'France',
    state: 'Auvergne',
  },
  {
    country: 'France',
    state: 'Occitaine',
  },
  {
    country: 'France',
    state: "Provence-Alpes-Côted'Azur",
  },
  {
    country: 'France',
    state: 'Corse',
  },
  {
    country: 'Norway',
    state: 'Troms og Finnmark',
  },
  {
    country: 'Kosovo',
    state: 'Prizren',
  },
  {
    country: 'Kosovo',
    state: 'Pristina',
  },
  {
    country: 'Serbia',
    state: 'Rasina Administrative District',
  },
  {
    country: 'Ireland',
    state: 'Mallow',
  },
  {
    country: 'Pakistan',
    state: 'Islamabad',
  },
  {
    country: 'Pakistan',
    state: 'Faisalabad',
  },
  {
    country: 'Pakistan',
    state: 'Lahore',
  },
  {
    country: 'Pakistan',
    state: 'Gujranwala',
  },
  {
    country: 'Pakistan',
    state: 'Gujrat',
  },
  {
    country: 'Pakistan',
    state: 'Sargodha',
  },
  {
    country: 'Pakistan',
    state: 'Abbottabad',
  },
  {
    country: 'Pakistan',
    state: 'Muzzffarabad',
  },
  {
    country: 'Pakistan',
    state: 'Peshawar',
  },
  {
    country: 'Pakistan',
    state: 'Karachi',
  },
  {
    country: 'Pakistan',
    state: 'Nawabshah',
  },
  {
    country: 'Pakistan',
    state: 'Dadu',
  },
  {
    country: 'Pakistan',
    state: 'Sukkur',
  },
  {
    country: 'Pakistan',
    state: 'Ghotki',
  },
  {
    country: 'Pakistan',
    state: 'Zahor Pir',
  },
  {
    country: 'Pakistan',
    state: 'Uch Sharif',
  },
  {
    country: 'Pakistan',
    state: 'Jalalpur Pirwala',
  },
  {
    country: 'Pakistan',
    state: 'Hyderabad',
  },
  {
    country: 'Pakistan',
    state: 'Zareef Shaheed',
  },
  {
    country: 'Pakistan',
    state: 'Multan',
  },
  {
    country: 'Pakistan',
    state: 'Basti Tibba',
  },
  {
    country: 'Pakistan',
    state: 'Makhdoom Pur Pahuran',
  },

  {
    country: 'Ireland',
    state: 'Limerick',
  },
  {
    country: 'Ireland',
    state: 'Killarney',
  },
  {
    country: 'Ireland',
    state: 'Cork',
  },
  {
    country: 'Ireland',
    state: 'Clonmel',
  },
  {
    country: 'Ireland',
    state: 'Waterford',
  },
  {
    country: 'Ireland',
    state: 'Castlebar',
  },
  {
    country: 'Ireland',
    state: 'Galway',
  },
  {
    country: 'Ireland',
    state: 'Sligo',
  },
  {
    country: 'Ireland',
    state: 'Omagh',
  },
  {
    country: 'Ireland',
    state: 'Lisburn',
  },
  {
    country: 'Ireland',
    state: 'Dublin',
  },
  {
    country: 'United States',
    state: 'Puerto Rico',
  },
  {
    country: 'Colombia',
    state: 'Barranquilla',
  },
  {
    country: 'Colombia',
    state: 'Cartagena',
  },
  {
    country: 'Colombia',
    state: 'Monteria',
  },
  {
    country: 'Colombia',
    state: 'Valledupar',
  },
  {
    country: 'Colombia',
    state: 'Bucaramanga',
  },
  {
    country: 'Colombia',
    state: 'Medellin',
  },
  {
    country: 'Colombia',
    state: 'Quibdó',
  },
  {
    country: 'Colombia',
    state: 'Manizales',
  },
  {
    country: 'Colombia',
    state: 'Pereira',
  },
  {
    country: 'Colombia',
    state: 'Armenia',
  },
  {
    country: 'Colombia',
    state: 'Tuluá',
  },
  {
    country: 'Colombia',
    state: 'Cali',
  },
  {
    country: 'Colombia',
    state: 'Popayán',
  },
  {
    country: 'Colombia',
    state: 'Bogota',
  },
  {
    country: 'Colombia',
    state: 'Facatativá',
  },
  {
    country: 'Colombia',
    state: 'Fusagasugá',
  },
  {
    country: 'Colombia',
    state: 'Funza',
  },
  {
    country: 'Colombia',
    state: 'Choachí',
  },
  {
    country: 'Colombia',
    state: 'Cáqueza',
  },
  {
    country: 'Colombia',
    state: 'Machetá',
  },
  {
    country: 'Colombia',
    state: 'Gachancipá',
  },
  {
    country: 'Colombia',
    state: 'Sesquilé',
  },
  {
    country: 'Colombia',
    state: 'Chocontá',
  },
  {
    country: 'Colombia',
    state: 'La Paz',
  },
  {
    country: 'Ecuador',
    state: 'Ibarra',
  },
  {
    country: 'Ecuador',
    state: 'Quito',
  },
  {
    country: 'Ecuador',
    state: 'Latacunga',
  },
  {
    country: 'Ecuador',
    state: 'Ambato',
  },
  {
    country: 'Ecuador',
    state: 'Riobamba',
  },
  {
    country: 'Ecuador',
    state: 'Guayaquil',
  },
  {
    country: 'Ecuador',
    state: 'Santa Elena',
  },
  {
    country: 'Peru',
    state: 'Piura',
  },
  {
    country: 'Peru',
    state: 'Chiclayo',
  },
  {
    country: 'Peru',
    state: 'Cajamarca',
  },
  {
    country: 'Peru',
    state: 'Mendoza',
  },
  {
    country: 'Peru',
    state: 'Huánuco',
  },
  {
    country: 'Peru',
    state: 'Cerro de Pasco',
  },
  {
    country: 'Peru',
    state: 'Huaral',
  },
  {
    country: 'Peru',
    state: 'Lima',
  },
  {
    country: 'Peru',
    state: 'Mala District',
  },
  {
    country: 'Peru',
    state: 'Tarma',
  },
  {
    country: 'Peru',
    state: 'Huancayo',
  },
  {
    country: 'Peru',
    state: 'Ica',
  },
  {
    country: 'Peru',
    state: 'Ayacucho',
  },
  {
    country: 'Peru',
    state: 'Arequipa',
  },
];
